<template>
    <div>
        <!--  便签 -->
        <div class="container slogan">
            <div class="item">
                <div class="img">
                    <img src="../assets/slogan01.png" />
                </div>
                <div class="word">材料单体一站式采购平台</div>
            </div>

            <div class="item">
                <div class="img">
                    <img src="../assets/slogan02.png" />
                </div>
                <div class="word">数百种现货直发</div>
            </div>

            <div class="item">
                <div class="img">
                    <img src="../assets/slogan03.png" />
                </div>
                <div class="word">高品质高效率</div>
            </div>

            <div class="item">
                <div class="img">
                    <img src="../assets/slogan04.png" />
                </div>
                <div class="word">专注于前沿技术材料</div>
            </div>
        </div>
        <div class="footer">
            <div class="container">
                <div class="item" v-for="(val, index) in categoryList" :key="index">
                    <div class="title">{{ val.name }}</div>

                    <ul class="link">
                        <li v-for="(v, i) in val.childList" :key="i" @click="toItem(v)">
                            {{ v.name }}
                        </li>
                    </ul>
                </div>
            </div>

            <div data-v-5d863138 class="footertext">
                地址：上海市闵行区洱海路99弄23号102 联系人：张小姐 联系QQ：583108144
                <br />Copyright 版权所有 备案号：
                <a
                    href="https://beian.miit.gov.cn"
                    target="_blank"
                    style="color:#ffffff;text-decoration: underline;"
                    >沪ICP备17051290号-2</a
                >
                GoogleSitemap 上海腾骞生物科技有限公司 <br />技术支持：<a
                    style="color:#ffffff"
                    href="http://www.jiefengchem.top"
                    target="_blank"
                    >南京杰锋网络科技有限公司</a
                >
            </div>
        </div>
    </div>
</template>

<script>
import * as apis from '../fetch/common';

export default {
    name: 'v-footer',
    data() {
        return {
            categoryList: [],
        };
    },
    methods: {
        getCategoryList() {
            apis.getCategoryList('bottom').then(res => {
                this.categoryList = res;
            });
        },
        toItem(val) {
            if (val.code === 'product_catalog_download') {
                this.$router.push('/proindex');
            } else if (val.code === 'technical_information') {
                this.$router.push('/news-list');
            } else if (val.code === 'customized_synthesis') {
                this.$router.push('/promade');
            } else if (val.code === 'quality_certificate_coa') {
                this.$router.push('/coa');
            } else {
                this.$router.push('/introduce/' + val.code);
            }
        },
    },
    mounted() {
        this.getCategoryList();
    },
};
</script>

<style lang="less" scoped>
.footer {
    margin-top: 100px;
    width: 100%;
    padding-bottom: 20px;
    background: #3c9539;
    .container {
        width: 1100px;
        display: flex;
        justify-content: space-between;
        .item {
            margin-top: -25px;
            .title {
                width: 120px;
                height: 40px;
                background-color: #f1f1f1;
                line-height: 40px;
                text-align: center;
                font-size: 14px;
                color: #727272;
                position: relative;
            }
            .title::before {
                content: '';
                border-right: 20px solid #f1f1f1;
                border-top: 20px solid transparent;
                border-bottom: 20px solid transparent;
                position: absolute;
                top: 0;
                left: -20px;
            }
            .title::after {
                content: '';
                border-left: 20px solid #f1f1f1;
                border-top: 20px solid transparent;
                border-bottom: 20px solid transparent;
                position: absolute;
                top: 0;
                right: -20px;
            }
            .link {
                padding-left: 0;
                li {
                    font-size: 12px;
                    line-height: 40px;
                    text-align: center;
                    list-style: none;
                    color: #fff;
                    cursor: pointer;
                }
            }
        }
    }

    .footertext {
        text-align: center;
        color: #ffffff;
        font-size: 14px;
        line-height: 30px;
    }
}

.slogan {
    margin-top: 50px;
    height: 100px;
    display: flex;
    .item {
        text-align: center;
        flex: 1;
        img {
            width: 60px;
        }
        .word {
            color: #3b3f4d;
            font-size: 14px;
            line-height: 60px;
        }
    }
}
</style>
